module.exports = __webpack_public_path__ + "static/media/icon-ok-green.7c4b250d.svg";